import AuthLayout from "../../Layout/Auth";
import {Alert, Box, Button, Group, List, Text, ThemeIcon, Title} from "@mantine/core";
import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useTimeout} from "@mantine/hooks";
import {IconShare3, IconSquarePlus} from "@tabler/icons-react";
import {isIOS, isIOSSafari, isStandalone} from "../../../utils/pwa";

const DownloadApp = () => {
  const navigate = useNavigate()
  const installPrompt = useRef<any>()

  const [ready, setReady] = useState(false)

  // iOS has no beforeinstallprompt — the app can only be installed by hand
  // from the share sheet, so we show instructions instead of a dead button.
  const ios = isIOS()

  const timeout = useTimeout(() => {
    if (!installPrompt.current) {
      navigate("/")
    }
  }, 1000)

  useEffect(() => {
    if (isStandalone()) {
      navigate("/")
      return
    }

    const onPrompt = (event: Event) => {
      event.preventDefault();
      installPrompt.current = event;
      setReady(true)
    }

    window.addEventListener("beforeinstallprompt", onPrompt);

    // Only bail out to the app when a prompt could realistically arrive.
    if (!ios) timeout.start()

    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt)
      timeout.clear()
    }
  }, []);

  const handleDownload = () => {
    if (installPrompt.current) installPrompt.current.prompt();
  }

  if (ios) {
    return (
      <AuthLayout>
        <Title ta="center">
          Nainstaluj si apku!
        </Title>
        <Text c="dimmed" size="sm" ta="center" mt={5}>
          Budeš mít vše hned poruce a nemusíš se pokaždé přihlašovat.
        </Text>

        {isIOSSafari() ? (
          <List spacing="sm" mt="xl" type="ordered">
            <List.Item>
              <Group gap={6} wrap="nowrap">
                <Text span size="sm">Klepni na</Text>
                <ThemeIcon variant="light" color="blue" size="sm">
                  <IconShare3 size={14}/>
                </ThemeIcon>
                <Text span size="sm">Sdílet dole v Safari</Text>
              </Group>
            </List.Item>
            <List.Item>
              <Group gap={6} wrap="nowrap">
                <Text span size="sm">Vyber</Text>
                <ThemeIcon variant="light" color="blue" size="sm">
                  <IconSquarePlus size={14}/>
                </ThemeIcon>
                <Text span size="sm">Přidat na plochu</Text>
              </Group>
            </List.Item>
            <List.Item>
              <Text span size="sm">Potvrď tlačítkem <b>Přidat</b> vpravo nahoře</Text>
            </List.Item>
          </List>
        ) : (
          <Alert color="yellow" mt="xl">
            Apku jde na iPhonu nainstalovat jen ze Safari. Otevři si tuhle stránku
            v Safari a pak klepni na <b>Sdílet</b> → <b>Přidat na plochu</b>.
          </Alert>
        )}

        <Box mt="xl">
          <a href="/">
            <Button variant="light" fullWidth>Pokračovat bez aplikace</Button>
          </a>
        </Box>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout>
      <Title ta="center">
        Nainstaluj si apku!
      </Title>
      <Text c="dimmed" size="sm" ta="center" mt={5}>
        Budeš mít vše hned poruce a nemusíš se pokaždé přihlašovat.
      </Text>

      <Box mt="xl">
        <Button color={"green"} fullWidth onClick={handleDownload} disabled={!ready}>Stáhnout appku</Button>
        <a href="/">
          <Button variant="light" mt="xs" fullWidth>Pokračovat bez aplikace</Button>
        </a>
      </Box>

    </AuthLayout>
  )
}

export default DownloadApp